import BaseInput from '@/components/Inputs/BaseInput.vue';
import BaseDropdown from '@/components/BaseDropdown.vue';
import Card from '@/components/Cards/Card.vue';
import Modal from '@/components/Modal.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseAlert from "@/components/BaseAlert";
import BaseNav from "@/components/Navbar/BaseNav";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Input, Tooltip, Popover } from 'element-ui';
import BaseSwitch from '@/components/BaseSwitch.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import LoadingPanel from '@/components/LoadingPanel.vue';
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(Card.name, Card);
    Vue.component(Modal.name, Modal);
    Vue.component(Input.name, Input);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component('validation-provider', ValidationProvider)
    Vue.component('validation-observer', ValidationObserver)
    Vue.use(Tooltip);
    Vue.use(Popover);
    Vue.component(LoadingPanel.name, LoadingPanel);
  }
};

export default GlobalComponents;
